module.exports = __webpack_public_path__ + "static/media/nav-deparments.86fa8311.png";